module.exports = __webpack_public_path__ + "img/ecampus-wht.a5bd8eba.svg";